import React from 'react';
import { Box, Typography } from '@mui/material';

/** 서브 페이지 공통 제목 바 (반응형) */
export default function PageTitle({ title, subtitle }) {
  return (
    <Box
      sx={{
        backgroundColor: '#EC9F46',
        borderRadius: '10px',
        px: { xs: 2, md: 3 },
        py: { xs: 1.2, md: 1.6 },
        mb: 2,
      }}
    >
      <Typography
        component='h1'
        sx={{ color: '#FCFCFC', fontSize: { xs: 18, md: 24 }, fontWeight: 700 }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ color: '#FFF6D8', fontSize: { xs: 12, md: 14 }, mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
